"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var typeahead_base_component_1 = require("./typeahead-base.component");
var typeahead_1 = require("@bhtp-client-api/typeahead");
var COUNTRY_TYPEAHEAD_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return TypeaheadCountryComponent; }),
    multi: true
};
var TypeaheadCountryComponent = (function (_super) {
    __extends(TypeaheadCountryComponent, _super);
    function TypeaheadCountryComponent(typeaheadService, zone) {
        return _super.call(this, typeaheadService, zone) || this;
    }
    return TypeaheadCountryComponent;
}(typeahead_base_component_1.TypeaheadBaseComponent));
TypeaheadCountryComponent = __decorate([
    core_1.Component({
        selector: 'typeahead-country',
        providers: [COUNTRY_TYPEAHEAD_VALUE_ACCESSOR],
        template: "<div class=\"bhtp-typeahead\">     <input #typeaheadInput class=\"form-control\"             clean-input             placeholder=\"{{placeHolder}}\"             [(ngModel)]=\"searchValue\"             name=\"{{placeHolder}}\"             [bhtpTypeahead]=\"dataSource\"             [typeaheadWaitMs] =\"typeAheadWaitInMs\"             (typeaheadOnSelect)=\"typeaheadOnSelect($event)\"             (typeaheadOnBlur)=\"typeaheadOnBlur($event)\"             (typeaheadNoResults)=\"changeTypeaheadNoResults($event)\"             (typeaheadLoading)=\"changeTypeaheadLoading($event)\"             [typeaheadOptionField]=\"itemDisplayPropertyName\"             [typeaheadOptionsLimit]=\"7\"             [typeaheadMinLength]=\"1\"             [disabled]=\"disabled\"             >     <div class=\"bhtp-typeahead-status\" [hidden]=\"typeaheadLoading!==true\">         <i class=\"glyphicon glyphicon-refresh ng-hide\"></i>     </div>     <div class=\"bhtp-typeahead-status\" [hidden]=\"typeaheadNoResults!==true\">         <i class=\"glyphicon glyphicon-remove\"></i> No Results Found     </div>     <div class=\"bhtp-typeahead-status dropdown-menu\" [hidden]=\"typeaheadLoading !== true\">         Searching {{searchValue}}     </div> </div>"
    }),
    core_1.Injectable(),
    __metadata("design:paramtypes", [typeahead_1.BhtpCountryTypeaheadService, core_1.NgZone])
], TypeaheadCountryComponent);
exports.TypeaheadCountryComponent = TypeaheadCountryComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/type-ahead/typeahead-country.component.js